import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M2 11.7c4.053-.05 6.331-.328 7.852-1.848 1.52-1.52 1.798-3.8 1.848-7.852A10.005 10.005 0 0 0 2 11.7ZM12.3 2c.05 4.053.328 6.331 1.848 7.852 1.52 1.52 3.8 1.798 7.852 1.848A10.005 10.005 0 0 0 12.3 2ZM22 12.3c-4.053.05-6.331.328-7.852 1.848-1.52 1.52-1.798 3.8-1.848 7.852a10.005 10.005 0 0 0 9.7-9.7ZM11.7 22c-.05-4.053-.328-6.331-1.848-7.852-1.52-1.52-3.8-1.798-7.852-1.848a10.005 10.005 0 0 0 9.7 9.7Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconSocialDzen24 = createIcon(IconComponent);